import { AiOutlineClose } from "react-icons/ai";

import type { ParkingRecord } from "@/apis/parking";
import Button from "@/components/Button";
import ModalLayout from "@/components/Layout/ModalLayout";
import { Badge, splitValues } from "@/pages/Admin/components/ParkingInfo";

interface Props {
  record: ParkingRecord;
  onEdit: () => void;
  onDelete: () => void;
  onClose: () => void;
}

const DetailRow = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <div className="flex items-start gap-3 py-2.5">
    <span className="w-16 shrink-0 text-xs font-medium text-gray-400">
      {label}
    </span>
    <div className="flex-1">{children}</div>
  </div>
);

const ParkingDetailModal = ({ record, onEdit, onDelete, onClose }: Props) => {
  return (
    <ModalLayout variant="primary" onClose={onClose}>
      <div className="relative z-50 flex w-[400px] flex-col px-6 py-5">
        {/* 헤더 */}
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-800">주차정보 상세</h3>
          <Button variant="icon" onClick={onClose}>
            <AiOutlineClose size={18} />
          </Button>
        </div>

        {/* 정보 */}
        <div className="divide-y divide-gray-100">
          <DetailRow label="이름">
            <Badge items={splitValues(record.name)} color="blue" />
          </DetailRow>
          <DetailRow label="연락처">
            <Badge items={splitValues(record.phone)} color="green" />
          </DetailRow>
          <DetailRow label="공동체">
            <span className="text-sm text-gray-700">
              {record.community || "-"}
            </span>
          </DetailRow>
          <DetailRow label="사역팀">
            <span className="text-sm text-gray-700">
              {record.team || "-"}
            </span>
          </DetailRow>
          <DetailRow label="차종">
            <span className="text-sm text-gray-700">
              {record.car || "-"}
            </span>
          </DetailRow>
          <DetailRow label="차량번호">
            <Badge items={splitValues(record.plate)} color="purple" />
          </DetailRow>
        </div>

        {/* 버튼 */}
        <div className="mt-5 flex justify-end gap-2">
          <Button
            variant="custom"
            onClick={onEdit}
            className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary/90"
          >
            수정
          </Button>
          <Button
            variant="custom"
            onClick={onDelete}
            className="rounded-lg border border-red-200 px-4 py-2 text-sm text-red-500 hover:bg-red-50"
          >
            삭제
          </Button>
        </div>
      </div>
    </ModalLayout>
  );
};

export default ParkingDetailModal;
